import api from "./api";

// エラーハンドリング関数
const handleError = (error, navigate, location) => {
    switch (error) {
        case 'unauthorized':
            navigate('/login', { state: { from: location.pathname } });
            break;
        case 'server_error':
            console.error('A server error occurred. Please try again later.');
            break;
        case 'unknown_error':
            console.error('An unknown error occurred.');
            break;
        default:
            console.error('Unexpected error:', error);
    }
};


export const fetchFinancialResults = async (secCode, navigate = null, location = null) => {
    try {
        const startTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/financial-results/${secCode}/`);
        const endTime = Date.now();
        // console.log('API call -- financial results --: ', endTime - startTime, ' ms');
        return { success: true, data: response.data }; // 成功時はオブジェクトで返す
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
};


export const getLatestAccountingStandard = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/latest-accounting-standard/${secCode}/`, {
        })
        const endTime = Date.now();
        // console.log('API call -- accounting standard --: ', endTime - stratTime, ' ms')
        return { success: true, data: response.data.accounting_standard }; // 成功時はオブジェクトで返す
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}   


export const fetchCompanyInfoData = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/company-info/${secCode}/`, {
        })
        const endTime = Date.now();
        // console.log('API call -- company info --: ', endTime - stratTime, ' ms')
        const companyInfoData = response.data
        const companyUrlResponse = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/company-hp-url/${secCode}/`);
        companyInfoData['url_japan'] = companyUrlResponse.data.url;
        return { success: true, data: companyInfoData }; // 成功時はオブジェクトで返す
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const checkIsRegistered = async (secCode, navigate = null, location = null) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/check-is-registered/${secCode}/`, {
        })
        return { success: true, data: response.data.is_registered }; // 成功時はオブジェクトで返す
    } catch (error) {
         // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}   

export const fetchLatestDividendData = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/dividend-time-series/${secCode}/`, {
            params: {
                limit: 1,
                exclude_forecast: true,
                total_only: true,
            }
        });
        const endTime = Date.now();
        // console.log('API call -- latest dividend --: ', endTime - stratTime, ' ms')

        if (response.data) {
            return { success: true, data: response.data[0] };
        } else {
            return { success: true, data: [] };
        }
        
    } catch (error) {
       // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}


export const fetchStockData = async (secCode, dataNum=null, navigate = null, location = null) => {
    try {
        // 降順
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/stock-price-time-series/${secCode}/`, {
            params: {
                dataNum: dataNum,
            }
        })
        const endTime = Date.now();
        // console.log('API call -- stock data --: ', endTime - stratTime, ' ms')
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchDividendData = async (secCode, totalOnly=true, excludeForecast=false, navigate = null, location = null) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/dividend-time-series/${secCode}/`, {
            params: 
            {
                total_only: totalOnly,
                exclude_forecast: excludeForecast, 
            }
        })
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}


const transformData = (data) => {
    // カテゴリーごとにメトリックをグループ化
    const groupedData = data.reduce((acc, item) => {
        // 既にカテゴリーが存在する場合は、その配列に追加
        const existingCategory = acc.find(group => group.category === item.category);
        
        if (existingCategory) {
            existingCategory.metrics.push({
                metric: item.metric,
                metric_name: item.metric_name,
                unit: item.unit,
            });
        } else {
            // 新しいカテゴリーを追加
            acc.push({
                category: item.category,
                metrics: [{
                    metric: item.metric,
                    metric_name: item.metric_name,
                    unit: item.unit,
                }]
            });
        }
        
        return acc;
    }, []);

    return groupedData;
};

export const fetchMeticsList = async (navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/accounts/api/metrics-list/`, {});
        const endTime = Date.now();
        // console.log('API call -- metrics list --: ', endTime - stratTime, ' ms')
        const transformed = transformData(response.data);
        return { success: true, data: transformed };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}


export const fetchForecastData = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/forecast-data/${secCode}/`, {
        })
        const endTime = Date.now();
        // console.log('API call -- forecast data --: ', endTime - stratTime, ' ms')
        if (response.data.consolidated) {
            return { success: true, data: response.data.consolidated };
        } else if (response.data.unconsolidated) {
            return { success: true, data: response.data.unconsolidated };
        } else {
            return []
        }
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchForecastCorrectionData = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/forecast-correction/${secCode}/`, {
        })
        const endTime = Date.now();
        // console.log('API call -- forecast correction data --: ', endTime - stratTime, ' ms')
        
        if (response.data.consolidated) {
            return { success: true, data: response.data.consolidated };
        } else if (response.data.unconsolidated) {
            return { success: true, data: response.data.unconsolidated };
        } else {
            return { success: true, data: null };
        }
        
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}


export const fetchIndustryFinancialData = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/industry-financial-data/${secCode}/`, {
        })
        const endTime = Date.now();
        // console.log('API call -- industry financial data --: ', endTime - stratTime, ' ms')
        
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchIndustryCompanies = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/industry-companies-country/${secCode}/`, {
        })
        const endTime = Date.now();
        // console.log('API call -- industry-companies-country --: ', endTime - stratTime, ' ms')
        
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}


export const fetchIndustryMarketData = async (secCode, date=null, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/industry-market-data/${secCode}/`, {
            params: {
                date: date,
            }
        })
        const endTime = Date.now();
        // console.log('API call -- industry market data --: ', endTime - stratTime, ' ms')
        
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchIndustryMarketDataEoY = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/industry-market-data-eoy/${secCode}/`, {})
        const endTime = Date.now();
        // console.log('API call -- industry market data eoy --: ', endTime - stratTime, ' ms')
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchIndustryInfo = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/company-industry/${secCode}/`, {
        })
        const endTime = Date.now();
        // console.log('API call -- forecast industry info --: ', endTime - stratTime, ' ms')
        
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchSimilarCompanies = async (secCode, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/similar-companies/${secCode}/`);
        const endTime = Date.now();
        // console.log('API call -- similar companies --: ', endTime - stratTime, ' ms')
        
        const companiesArray = Object.values(response.data).filter(company => company !== null); // null を除外
        return { success: true, data: companiesArray };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
};

export const fetchFinancialSummary = async (secCode, term, navigate = null, location = null) => {
    try {
        const stratTime = Date.now();
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/tanshin-summary/${secCode}/${term}/`, {});
        const endTime = Date.now();
        // console.log('API call -- financial summary --: ', endTime - stratTime, ' ms')
        
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}



export const fetchLatestQuarterlyFinancialData = async (secCode, navigate = null, location = null) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/latest-quarterly-financial-data/${secCode}/`, {});
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchLatestTanshinQuarterlyFinancialData = async (secCode, navigate = null, location = null) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/latest-tanshin-quarterly-financial-data/${secCode}/`, {});
        return { success: true, data: response.data };
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchQuarterlyFinancialData = async (secCode, accountCol=null, navigate = null, location = null) => {
    try {
        if (accountCol) {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/quarterly-financial-data/${secCode}/${accountCol}/`, {
            })
            return { success: true, data: response.data };
        } else {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/quarterly-financial-data/${secCode}/`, {
            })
            return { success: true, data: response.data };
        }
        
    } catch (error) {
        // エラーに応じた処理
        const errorType = 
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        // エラーハンドリング
        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
}

export const fetchTickData = async (secCode, dateFrom, dateTo, navigate = null, location = null) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/tick-data/`, {
            params: {
                sec_code: secCode,
                date_from: dateFrom,
                date_to: dateTo
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        const errorType =
            error.response && (error.response.status === 401 || error.response.status === 403)
                ? 'unauthorized'
                : error.response && error.response.status >= 500
                ? 'server_error'
                : 'unknown_error';

        if (navigate && location) {
            handleError(errorType, navigate, location);
        }

        return { success: false, error: errorType };
    }
};


export const getTickDateRange = () => {
    const now = new Date(); // 現在の日時（UTC）
    
    // JSTに変換（UTC+9）
    const jstOffset = 9 * 60 * 60 * 1000;
    const jstNow = new Date(now.getTime() + jstOffset);
  
    // 当日の日付（dateTo）
    const dateTo = jstNow.toISOString().split('T')[0]; 
  
    // 前日の日付（dateFrom）
    const jstYesterday = new Date(jstNow.getTime() - 24 * 60 * 60 * 1000);
    const dateFrom = jstYesterday.toISOString().split('T')[0];
  
    return { dateFrom, dateTo };
  };